import React from 'react';
import Account from 'components/Tvendo/Shopping/DataMaster/Account/Account.js';

export default function () {
  return <Account />;
}
